'use client';

import { Box, SxProps, Tab, Tabs, Theme } from '@mui/material';
import { useRouter } from 'next/navigation';
import { SyntheticEvent, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { BackButton } from '@components/Button/presets';
import { ErrorModal } from '@components/Modal/presets';

import { TaskData } from '@api/generator';

import { TabPanel } from './Panels/TabPanel';
import { TaskHistory } from './Panels/TaskHistory';
import { TasksData } from './Panels/TasksData';
import styles from './taskManagement.module.scss';

type TaskListTab = 'tasks' | 'taskhistory';

const languageNamespace = 'task-management';
const commonLanguageNamespace = 'common';

interface TabPanelProps {
  tasks: TaskData[];
  isApiError: boolean;
}
export function TaskManagement({ tasks, isApiError }: Readonly<TabPanelProps>) {
  const [currentTab, setCurrentTab] = useState<TaskListTab>('tasks');
  const [apiError, setApiError] = useState(false);

  const boxStyle: SxProps<Theme> = { borderBottom: 1, borderColor: 'divider', width: '100%' };
  const { t } = useTranslation([languageNamespace, commonLanguageNamespace]);
  const router = useRouter();

  const handleNavigation = (selectedTask: TaskData) => {
    if (selectedTask.task === 'Cash Count') {
      //To be implemented while developing the cash balance
      return;
    }
  };

  const handleRowClick = (item: TaskData) => (e: SyntheticEvent) => {
    e.preventDefault();
    handleNavigation(item);
  };
  const handleTabChange = (event: React.SyntheticEvent, newValue: TaskListTab) => {
    setCurrentTab(newValue);
  };
  const taskList = useMemo(() => {
    return (
      tasks?.map((item: TaskData) => {
        return { ...item, task: item.task === 'Cash Balance' ? 'Cash Count' : item.task };
      }) || []
    );
  }, [tasks]);

  useEffect(() => {
    setApiError(isApiError);
  }, [isApiError]);

  return (
    <div className={styles.containerMain}>
      <div>
        <BackButton onClick={router.back} />
      </div>
      <div className={styles.divMainTasklist}>
        <div className={styles.divTab}>
          <Box sx={boxStyle}>
            <Tabs value={currentTab} onChange={handleTabChange}>
              <Tab label={<span>{t('tasks')}</span>} value="tasks" />
              <Tab label={<span>{t('taskhistory')}</span>} value="taskhistory" />
            </Tabs>
          </Box>
        </div>
        <TabPanel value={currentTab} id={'tasks'}>
          <TasksData data={taskList} onRowClick={handleRowClick} />
        </TabPanel>
        <TabPanel value={currentTab} id={'taskhistory'}>
          <TaskHistory data={taskList} />
        </TabPanel>
      </div>
      {apiError && (
        <ErrorModal
          messages={[t('common:errors.BO004.message')]}
          errorCode={t('common:errors.BO004.errorCode')}
          onClick={() => setApiError(false)}
          retryOption
          buttonText={t('common:cancel')}
          appearance="secondary"
        />
      )}
    </div>
  );
}
